import { Injectable } from '@angular/core';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { Enums } from '../../shared/models/enums';
import { ModalService } from './../../shared/services/modal.service';


@Injectable()
export class ShowImagePreviewService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    constructor(
        private modalService: ModalService,
        public userPersistenceService: UserPersistenceService
    ) {
    }


}